import { format, isToday, isThisWeek, isThisMonth } from 'date-fns';

export const safeFormat = (date: any, formatStr: string, fallback = 'Invalid Date'): string => {
    if (!date) return 'N/A';
    try {
        const d = new Date(date);
        if (isNaN(d.getTime())) return fallback;
        // Check for extreme dates that might cause issues even if not NaN
        if (d.getFullYear() < 1000 || d.getFullYear() > 9999) return fallback;
        return format(d, formatStr);
    } catch (e) {
        console.error('safeFormat error:', e, date);
        return fallback;
    }
};

export const safeIsToday = (date: any): boolean => {
    if (!date) return false;
    try {
        const d = new Date(date);
        if (isNaN(d.getTime())) return false;
        return isToday(d);
    } catch (e) {
        return false;
    }
};

export const safeIsThisWeek = (date: any): boolean => {
    if (!date) return false;
    try {
        const d = new Date(date);
        if (isNaN(d.getTime())) return false;
        return isThisWeek(d);
    } catch (e) {
        return false;
    }
};

export const safeIsThisMonth = (date: any): boolean => {
    if (!date) return false;
    try {
        const d = new Date(date);
        if (isNaN(d.getTime())) return false;
        return isThisMonth(d);
    } catch (e) {
        return false;
    }
};
